import type {ListResult, Valuable} from 'src/typings';
import type {ObservableAjaxService} from 'core/data-services/observable-ajax.service';
import type {Observable} from 'rxjs';

export default class AutocompleteSearchDataService {
    public static serviceName = 'autocompleteSearchDataService';
    private baseUri: string;

    /*@ngInject*/
    constructor(private observableAjaxService: ObservableAjaxService) {
        this.baseUri = 'autocomplete';
    }

    public getSearchedTerms<TYPE = any>(infix: string): Observable<ListResult<Valuable<TYPE>>> {
        return this.observableAjaxService
            .forUri(`${this.baseUri}/searched-terms`)
            .get({infix});
    }
}
